import { render, staticRenderFns } from "./moveCreate.vue?vue&type=template&id=92c63c90&"
import script from "./moveCreate.vue?vue&type=script&lang=js&"
export * from "./moveCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports